import { HTMLAttributes } from 'react';
import Button from '../../components/button';
import './stats.scss';

interface Stat {
	label: string;
	value: string;
}

interface StatsProps extends HTMLAttributes<HTMLDivElement> {
	stats?: Array<Stat>;
	isGenerating?: boolean;
	onDownload?: () => void;
}

const Stats: React.FunctionComponent<StatsProps> = ({ stats = [], isGenerating, onDownload, children, ...props }) => {
	return (
		<div className="stats" {...props}>
			<div className="stats__container">
				{stats.map(({ label, value }) => {
					return (
						<div className="stats__stat" key={label}>
							<span className="stats__stat__value">{value}</span>
							<span className="stats__stat__label">{label}</span>
						</div>
					);
				})}
			</div>
			<Button style={{ textTransform: 'uppercase' }} isLoading={isGenerating} onClick={onDownload}>
				Print Directions
			</Button>
		</div>
	);
};

export default Stats;
